import { render, staticRenderFns } from "./MobileCranePermit.vue?vue&type=template&id=187ecfd0"
import script from "./MobileCranePermit.vue?vue&type=script&lang=js"
export * from "./MobileCranePermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports